import { Injectable } from "@angular/core";
import { MessagesDaoService } from "../message-dao.service";
import { LoggingService } from "src/app/_services/logging/logic/logging.service";
import { DbPersistenceService, Query } from "src/app/_services/persistence/db-persistence/db-persistence.service";
import { MessageDbTableDefinition } from "./message-db-table-definition";
import { Message } from "src/app/_model/message";
import { ro } from "date-fns/locale";

@Injectable()
export class MessagesDbDaoService implements MessagesDaoService {

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private dbPersistenceService: DbPersistenceService,
    private messageTableDefinition: MessageDbTableDefinition,
  ) { }

  public async addMessage(message: Message): Promise<void> {
    try {
      let db = await this.dbPersistenceService.getImsDb(); 
      let messageQuery: Query = {
        statement:
          'INSERT INTO ' +
            this.messageTableDefinition.tableName +
          '(text, receivedts, sentts, subject, senderId, sender, read)' + // 7
          ' VALUES (?,?,?,?,?,?,?)',
        parameters: [
          message.text,
          message.receivedTs,
          message.sentTs,
          message.subject,
          message.senderId,
          message.sender,
          message.read,
        ]
      };
        
      await this.dbPersistenceService.executeStatement(db, messageQuery);
    } catch (error) {
      this.logger.log(
        'Error saving message to db',
        error,
        '-',
        error.message
      );
    }
  }

  public async setMessageToRead(message: Message): Promise<void> {
    let db = await this.dbPersistenceService.getImsDb();
    let query: Query = {
      statement: `UPDATE ${this.messageTableDefinition.tableName} SET read = TRUE WHERE id = ${message.localId} ;`,
      parameters: [],
    };
    await this.dbPersistenceService.executeStatement(db, query);
  }

  public async getMessages(): Promise<Message[]> {
    let db = await this.dbPersistenceService.getImsDb();
    let messages: Message[] = [];

    try {
      // Get Messages
      let data = await this.dbPersistenceService.executeQuery(db, {
        statement: 'SELECT * FROM ' + this.messageTableDefinition.tableName + ';',
        parameters: null
      });
      for (let i = 0; i < data.values.length; i++) {
        let row = data.values[i];
        messages.push(
          new Message(
            row['text'],
            +row['receivedts'],
            +row['sentts'],
            +row['senderId'],
            row['sender'],
            row['subject'],
            row['id'],
            row['read'] === 1,
          )
        );
      }
    } catch (error) {
      this.logger.log('Error reading messages from db', error);
    }

    return messages;
  }

  public async reset() {
    // do nothing
  }

  public async clear() {
    let db = await this.dbPersistenceService.getImsDb();
    this.logger.log(this.constructor.name, "truncate table", this.messageTableDefinition.tableName)
    await this.dbPersistenceService.truncateTable(db, this.messageTableDefinition.tableName);
  }

}
